<template>
    <div id="conversation-with-experts"  v-on:keydown="(e)=>handleKeyDown(e)">
        <div id="chat-header">
            <div v-if="$store.state.expertDetail !== null">
               <div v-if="$store.state.expertDetail !== null">
                <div v-if="$store.state.alongExpertDetail == null" class="header-main-container">
                    <div v-if="$store.state.expertDetail.file!==null" class="expert-pic second-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.expertDetail.file+')'}">
                        <div class="online-status" v-if="$store.state.expertDetail.online_status"></div>
                    </div>
                    <div v-else class="expert-pic second-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}">
                        <div class="online-status"  v-if="$store.state.expertDetail.online_status"></div>
                    </div>
                    <div class="expert-name">
                        {{$store.state.expertDetail.name}}
                    </div>
                </div>
                <div v-else>
                    <div v-if="$store.state.expertDetail.online_status"  class="header-main-container">
                        <div  v-if="$store.state.alongExpertDetail.file!==null" class="expert-pic first-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.alongExpertDetail.file+')'}"></div>
                        <div  v-else class="expert-pic first-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}"></div>
                        <div v-if="$store.state.expertDetail.file!==null" class="expert-pic second-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.expertDetail.file+')'}">
                            <div class="online-status"></div>
                        </div>
                        <div v-else class="expert-pic second-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}">
                            <div class="online-status"></div>
                        </div>
                        <div class="expert-name">
                            {{$store.state.expertDetail.name}}
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="$store.state.alongExpertDetail.online_status"  class="header-main-container">
                            <div  v-if="$store.state.expertDetail.file!==null" class="expert-pic first-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.expertDetail.file+')'}"></div>
                            <div  v-else class="expert-pic first-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}"></div>
                            <div v-if="$store.state.alongExpertDetail.file!==null" class="expert-pic second-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.alongExpertDetail.file+')'}">
                                <div class="online-status"></div>
                            </div>
                            <div v-else class="expert-pic second-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}">
                                <div class="online-status"></div>
                            </div>
                            <div class="expert-name">
                                {{$store.state.alongExpertDetail.name}}
                            </div>
                        </div>
                        <div v-else  class="header-main-container">
                            <div  v-if="$store.state.alongExpertDetail.file!==null" class="expert-pic first-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.alongExpertDetail.file+')'}"></div>
                            <div  v-else class="expert-pic first-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}"></div>
                            <div v-if="$store.state.expertDetail.file!==null" class="expert-pic second-expert-pic" :style="{backgroundImage:'url('+$store.state.base_urls.adminsUploads+$store.state.expertDetail.file+')'}"></div>
                            <div v-else class="expert-pic second-expert-pic"  :style="{backgroundImage:'url('+require('../../assets/defaults/man.jpg')+')'}"></div>
                            <div class="expert-name">
                                {{$store.state.expertDetail.name}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div v-if="mode=='chatting'" class="group-messages-header-box" v-on:click="changeMode('group-messaging')">
                <img  width="36" src="../../assets/new/New/Icon/icons8-group-message-100.png" alt="">
                <span v-if="groupsUnreadMessagesCount">{{groupsUnreadMessagesCount}}</span>
            </div>
            <div v-else class="group-messages-header-box" v-on:click="changeMode('chatting')">
                <img  width="36" src="../../assets/new/New/Icon/icons8-edit-chat-history-100.png" alt="">
            </div>
        </div>
        <div id="chat-body">
                <div   class="message-content" v-for="(message,index) in messages" v-bind:class="{ expert : message.side=='admin' , user : message.side=='user' }" :key="message">
                    <div  v-bind:class="{ 'expert-text-container' : message.side=='admin' , 'user-text-container' : message.side=='user' }" >
                        <div  v-bind:class="{ 'expert-text-container-box' : message.side=='admin' , 'user-text-container-box' : message.side=='user' }" >
                            <div v-if="message.text!==null">
                                <TextMessage
                                        :status="message.status"
                                        :textContent = "message.text"
                                        :side = "message.side"
                                        :createdAt = "message.created_at"
                                        :submitKey = "submitKey"
                                        :currentDate = "message.currentDate"
                                        :relatedAdmin = "message.related_admin"
                                />
                            </div>
                            <div v-else>
                                <div style="padding: 0" v-if="message.file_type=='wav'">
                                    <AudioPlayer v-if="message.status"
                                                 :side="message.side"
                                                 :audioSrc="message.file_address"
                                                 :status="message.status"
                                                 :createdAt = "message.created_at"
                                                 :fileType="message.file_type"
                                                 :uniqueId="'audio'+index"
                                                 :fileSrc="message.file_address"
                                                 :currentDate="message.currentDate"
                                                 :filePreviousName="message.file_previous_name"
                                                 :fileContent="message.fileContent"
                                                 :submitKey="submitKey"
                                                 :relatedAdmin = "message.related_admin"
                                    />
                                    <AudioPlayer v-else
                                                 :side="message.side"
                                                 :audioSrc="$store.state.base_urls.messagesUploads + message.file_name"
                                                 :status="message.status"
                                                 :fileType="message.file_type"
                                                 :createdAt = "message.created_at"
                                                 :uniqueId="'audio'+index"
                                                 :currentDate="message.currentDate"
                                                 :filePreviousName="message.file_previous_name"
                                                 :fileContent="message.fileContent"
                                                 :submitKey="submitKey"
                                                 :relatedAdmin = "message.related_admin"
                                    />
                                </div>
                                <div v-else>
                                    <FilePlayer v-if="message.status"
                                                :side="message.side"
                                                :fileSrc="message.file_address"
                                                :fileType="message.file_type"
                                                :createdAt = "message.created_at"
                                                :currentDate="message.currentDate"
                                                :status="message.status"
                                                :filePreviousName="message.file_previous_name"
                                                :fileContent="message.fileContent"
                                                :submitKey="submitKey"
                                                :relatedAdmin = "message.related_admin"
                                    />
                                    <FilePlayer v-else
                                                :side="message.side"
                                                :fileSrc="$store.state.base_urls.messagesUploads + message.file_name"
                                                :fileType="message.file_type"
                                                :createdAt = "message.created_at"
                                                :currentDate="message.currentDate"
                                                :status="message.status"
                                                :filePreviousName="message.file_previous_name"
                                                :fileContent="message.fileContent"
                                                :submitKey="submitKey"
                                                :relatedAdmin = "message.related_admin"
                                    />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div v-if="message.side=='admin'" v-bind:class="{ 'expert-pic-container' : message.side=='admin'}">
                        <img v-if="message.related_admin.file !==null" width="40"  height="40" :src="$store.state.base_urls.adminsUploads + message.related_admin.file" alt="">
                        <img v-else width="40"  height="40" :src="require('../../assets/defaults/man.jpg')" alt="">
                    </div>
                </div>
        </div>
        <div id="chat-footer"  v-if="mode=='chatting'">

                    <div class="chat-footer-section" id="chat-footer-section" v-bind:class="{ active : recordingMode!=='start' }">

                        <button class="startBtn"  v-if="recordingMode=='start' && textContent==''" v-on:click="handleRecording('start')">
                            <img width="17" height="24" src="../../assets/appIcons/Panel/Microphone.png" alt="">
                        </button>
                        <button class="startBtn" v-if="recordingMode!=='recording' &&  textContent!==''" v-on:click="uploadText()">
                            <img width="20" height="20" src="../../assets/appIcons/Panel/Send.png" alt="">
                        </button>
                        <button class="sendBtn" v-show="recordingMode=='recording'" v-on:click="handleRecording('stop')">
                            <span class="iconify recorder-icon" data-icon="akar-icons:check" data-inline="false"></span>
                        </button>
                        <div  v-show="recordingMode=='recording'" class="timer">{{recordingTime}}</div>
                        <button class="clearBtn" v-show="recordingMode=='recording'" v-on:click="handleRecording('clear')">
                            <span class="iconify recorder-icon" data-icon="codicon:close" data-inline="false"></span>
                        </button>

                    </div>

                <div class="chat-footer-section" id="text-input">
                    <input type="text"  v-model="textContent"  placeholder="پیامی بنویسید..."> <!--ok-->
                </div>

                <div class="chat-footer-section" id="file-input">
                    <input id="attachment-input" v-on:change="e=>uploadFile(e,'attachment')" class="file_input" type="file" name="file"/> <!--ok-->
                    <label id="attachment-label" for="attachment-input">
                        <img width="24" height="24" src="../../assets/appIcons/Panel/Attach.png" alt="">
                    </label>
                </div>

        </div>
    </div>
    <PanelLoader v-if="loadingMood"/>

</template>

<script>
    import Recorder from 'recorder-js'
    const audioContext =  new (window.AudioContext || window.webkitAudioContext)();
    const recorder = new Recorder(audioContext, {});
    navigator.mediaDevices.getUserMedia({audio: true}).then(stream => recorder.init(stream)).catch(err => console.log('Uh oh... unable to get stream...', err));
    import AudioPlayer from '../../components/AudioPlayer'
    import FilePlayer from '../../components/FilePlayer'
    import TextMessage from '../../components/TextMessage'
    import PanelLoader from '../../components/PanelLoader'
    import axios from 'axios'
    import Pusher from 'pusher-js';
    export default {
        name: "ConversationWithExperts",
        data(){
            return{
                mode:this.$route.params.mode,
                isRecording:false,
                textContent:'',
                inputMode:'startRecording',
                recordingMode:'start',
                recordingTime:'00 : 00',
                timerInterval:null,
                status:'sent',
                contacts:[{
                    id:null,
                    unique_id:null,
                    email:null,
                    name:null,
                    unread_messages_count:null
                }],
                submitKey:0,
                messages:null,
                loadingMood:false,
                groupsUnreadMessagesCount:0
            }
        },
        components:{TextMessage,AudioPlayer,FilePlayer,PanelLoader},
        methods:{
            changeMode(type){
                this.$router.push(type);
                this.mode = type;
            },
            recordingTimer: function () {
                let seconds = -1;
                let minutes = 0;
                let finalSecondsResult = 0;
                let finalMinutesResult = 0;
                this.timerInterval=setInterval(() => {
                    seconds += 1;
                    if(seconds==60){
                        minutes+=1;
                        seconds =0;
                    }
                    if(seconds<10) {
                        finalSecondsResult = '0'+seconds
                    }else{
                        finalSecondsResult = seconds
                    }
                    if(minutes<10) {
                        finalMinutesResult = '0'+minutes
                    }else{
                        finalMinutesResult = minutes
                    }
                    this.recordingTime = finalSecondsResult + ' : ' + finalMinutesResult;
                }, 1000)
            },
            handleRecording(mode){
                clearInterval(this.timerInterval);
                this.recordingTime='00 : 00';
                if(mode=='start'){
                    this.recordingMode='recording';
                    this.recordingTimer();
                    this.startRecording();
                }else if(mode=='clear'){
                    this.recordingMode='start';
                    this.pauseRecording();
                    this.clearRecording();
                }else if(mode=='stop'){
                    this.recordingMode='start';
                    this.stopRecording();
                }
            },
            startRecording() {recorder.start().then(() => this.isRecording = true);},
            pauseRecording() {},
            stopRecording() {recorder.stop().then(({blob}) => {this.createDownloadLink(blob)});},
            createDownloadLink(blob) {this.uploadFile(blob,'voiceContent');},
            clearRecording() {},
            changeChannel(unique_id){
                Pusher.logToConsole = true;
                let pusher = new Pusher('cbbfe2a7885f291a7196', {
                    cluster: 'eu'
                });
                let channel = pusher.subscribe(`messages.${unique_id}`);
                channel.bind('new-message', (data) => {
                    if(data.message.side!=='user'){
                        this.messages.push(data.message);
                    }
                });
            },
            uploadText(){
                let checkSpace = this.textContent.replace(/\s/g, "");
                if(checkSpace !== ""){
                    this.URLFinder();
                    let date = new Date();
                    let currentDate = date.getMilliseconds();
                    this.messages.push
                    ({
                        text:this.textContent,
                        side:'user',
                        status:'send',
                        currentDate:currentDate.toString(),
                        created_at: this.currentTime()
                    });
                    this.scrollToTop();
                    localStorage.removeItem('currentDate');
                    localStorage.setItem('currentDate',currentDate);
                    if(this.submitKey==0){
                        this.submitKey=1
                    }else{
                        this.submitKey=0
                    }
                    this.textContent='';
                }
            },
            URLFinder(){
                const text = this.textContent;
                let urlRegex = /(https?:\/\/[^\s]+)/g;
                this.textContent =  text.replace(urlRegex, function(url) {
                    return '<a href="' + url + '" target="_blank" class="text-link">' + url + '</a>';
                })
            },
            uploadFile(e,type){
                let date = new Date();
                let currentDate = date.getMilliseconds();
                if(type =='attachment'){
                    const file = e.target.files[0];
                    const fr = new FileReader();
                    fr.readAsDataURL(file);
                    const blob = new Blob([file], { type: file.type });
                    const url = window.URL.createObjectURL(blob);
                    this.messages.push
                    ({
                        unique_id:null,
                        text:null,
                        receiver_id:null,
                        sender_id:null,
                        side:'user',
                        file_address:url,
                        file_previous_name:file.name,
                        file_name:null,
                        file_type:/[^.]+$/.exec(file.name)[0],
                        file_size:null,
                        status:'send',
                        currentDate:currentDate.toString(),
                        fileContent:file,
                        created_at: this.currentTime()
                    });
                    localStorage.removeItem('currentDate');
                    localStorage.setItem('currentDate',currentDate);
                    this.scrollToTop();
                }else{
                    const file = new File([e], 'test.wav');
                    let url = URL.createObjectURL(e);
                    this.messages.push
                    ({
                        unique_id:null,
                        text:null,
                        receiver_id:null,
                        sender_id:null,
                        side:'user',
                        file_address:url,
                        file_previous_name:new Date().toISOString() + '.wav',
                        file_name:null,
                        file_type:'wav',
                        file_size:null,
                        status:'send',
                        currentDate:currentDate.toString(),
                        fileContent:file,
                        created_at: this.currentTime()
                    });
                    localStorage.removeItem('currentDate');
                    localStorage.setItem('currentDate',currentDate);
                    this.scrollToTop();
                }

                if(this.submitKey==0){
                    this.submitKey=1
                }else{
                    this.submitKey=0
                }
            },
            scrollToTop(){
                let container = document.getElementById('chat-body');
                if(container!==null){
                    container.scrollTop = container.scrollHeight;
                }
            },
            handleKeyDown(e){
                if (e.which == 13) {
                    this.uploadText()
                }
            },
            currentTime(){
                let date = new Date();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                if(hours<10) {
                    hours = this.changeNumbersToPersian(0)+this.changeNumbersToPersian(hours);
                }else{
                    hours = this.changeNumbersToPersian(hours);
                }
                if(minutes<10) {
                    minutes = this.changeNumbersToPersian(0)+this.changeNumbersToPersian(minutes);
                }else{
                    minutes = this.changeNumbersToPersian(minutes);
                }
                return hours+":"+minutes
            },
            changeNumbersToPersian(n){
                const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

                return n
                    .toString()
                    .split('')
                    .map(x => farsiDigits[x])
                    .join('');
            },
            async getChatMessages() {
                try {
                    this.loadingMood = true;
                     let response  = await axios.get('/api/userDashboard/getChatMessages',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                        this.messages = response.data.results;
                        this.groupsUnreadMessagesCount = response.data.groupsUnreadMessagesCount;
                        const unique_id = localStorage.getItem('unique_id');
                        this.changeChannel(unique_id);
                        this.scrollToTop();
                        this.loadingMood = false;
                }catch (error) {
                    console.log(error);
                }
            },
            async getGroupMessages() {
                try {
                    this.loadingMood = true;
                    let response  = await axios.get('/api/userDashboard/getGroupMessages',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                        this.messages = response.data.results;
                        this.groupsUnreadMessagesCount = 0;
                    this.scrollToTop();
                    this.loadingMood = false;
                }catch (error) {
                    console.log(error);
                }

            },
        },
        watch:{
            mode:function () {
                if(this.mode == 'group-messaging'){
                    this.getGroupMessages();
                }else{
                    this.getChatMessages();
                }
            }
        },
        created(){
            if(this.mode == 'group-messaging'){
                this.getGroupMessages();
            }else{
                this.getChatMessages();
            }
        },
        updated(){
            this.scrollToTop();
        },
    }
</script>

<style lang="scss" scoped>

    .header-main-container{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .sender-details{
        background-color: transparent;color: grey;text-align: center;font-size: 10px
    }
    #attachment-label{
        cursor: pointer;
        margin-top: 10px;
    }
    #attachment-input{
        display: none;
    }

    .recorder-icon{
        margin-right: -1px!important;
        margin-top: 2px!important;
    }
    #chat-footer-section{
        border-left: 1px solid #e3e3e3;
    }
    #file-input{
        border-right: 1px solid #e3e3e3;
    }
    .expert-comment-time,.user-comment-time{
        opacity: 0.5;
        font-family: IRANSans;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #000000;
        width: 100%;
        height: 30px;
        display: block!important;
        line-height: 30px;
    }
    .user-comment-time{
        text-align: left;
    }
    .expert-comment-time{

    }

    .expert-text-container-box{
        margin: 20px 20px 20px 0;
        /*margin: 20px;*/

        padding: 6px;
        background-color: #f2f2f2;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        border-radius: 10px;
        position: relative;
    }

    .expert-text-container-box::before {
        content: '';
        position: absolute;
        visibility: visible;
        top: 0;
        left: -10px;
        border: 15px solid transparent;
        border-top: 15px solid #f2f2f2;
        border-radius: 2px;
    }

    .expert-text-container-box::after {
        content: '';
        position: absolute;
        visibility: visible;
        top: 0;
        left: -8px;
        border: 15px solid transparent;
        border-top: 15px solid #f2f2f2;
        clear: both;
        border-radius: 2px;
    }



    .user-text-container-box::before {
        content: '';
        position: absolute;
        visibility: visible;
        top: 0;
        right: -10px;
        border: 15px solid transparent;
        border-top: 15px solid #fef0ef;
        border-radius: 2px;
    }
    .user-text-container-box::after {
        content: '';
        position: absolute;
        visibility: visible;
        top: 0;
        right: -8px;
        border: 15px solid transparent;
        border-top: 15px solid #fef0ef;
        clear: both;
        border-radius: 2px;
    }

    .user-text-container-box{
        margin: 20px 0 20px 20px;
        /*margin: 20px;*/
        padding: 6px;
        background-color: #fef0ef;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
        border-radius: 10px;
        position: relative;

    }

    .user{
        padding-left: 35%;
        margin-right: 20px;
        display: flex;
        justify-content: flex-start;
        .user-text-container{
            width: auto;
            height: auto;
        }
    }




    .expert{
        padding-right: 25%;
        display: flex;
        justify-content: flex-end;
        /*align-items: ; */
        .expert-pic-container {
            img{
                border-radius: 50%;
            }
            width: 80px;
            height: auto;
        }
        .expert-text-container{
            max-width: calc( 100%  - 80px );
            width: auto;
            height: auto;
        }
    }


    #chat-body{
        .message-content{
            padding-top: 15px;
            width: 100%;
            height: auto;
        }
        overflow:hidden;
        overflow-y: scroll;
        width: 100%;
        height: 550px;
        margin: 0;
    }


    #chat-body::-webkit-scrollbar {
        display: none;
        width: 2px;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    #chat-body {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    #chat-body{
        width: 100%;
        height: auto;
    }



    ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: black;
    }
    ::-moz-placeholder { /* Firefox 19+ */
        color: black;
    }
    :-ms-input-placeholder { /* IE 10+ */
        color: black;
    }
    :-moz-placeholder { /* Firefox 18- */
        color: black;
    }
    .online-status{
        position: absolute;
        width: 15px;
        height: 15px;
        bottom: -2px;
        left: -2px;
        border-radius: 50%;
        background-color: #4ad41a;
    }
    #chat-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #162336;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        padding: 10px 20px;
    }
    .group-messages-header-box{
        position: relative;
        color: #fe7063 !important;
        cursor: pointer;
        span{
            color: #fe7063 !important;
            right: -15px;
            position: absolute;
            bottom: -8px;
            font-size: 18px;
            font-weight: bolder;
        }
    }

    .expert-pic{
        border-radius: 50%;
        background-size: cover;
        background-repeat: no-repeat;
        display: inline-block;
    }
    .first-expert-pic{
        width: 30px;
        height: 30px;
        display: inline-block;
    }
    .second-expert-pic{
        position: relative;
        width: 40px;
        height: 40px;
        margin-right: -10px;
        display: inline-block;
    }
    .expert-name{
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        margin-right: 14px;
        color: white;
        display: inline-block;
    }



    #chat-footer{
        border-top: 2px solid #e3e3e3;

        display: flex;
        justify-content: space-between;
        align-items: center;
        #chat-footer-section ,  #file-input{
            width: 50px;
        }
        #text-input{
            input{
                border: none;
                //border-top: 1px solid #e3e3e3;
                width: 100%;
                height: 48px;
                margin-top: 1px;
                margin-bottom: 1px;
                line-height: 50px;
                padding: 0 10px;
                /*opacity: 0.5;*/
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: normal;
                text-align: right;
                color: #1a1a1a;
            }
            width: calc( 100%  - 100px );
        }

        /*div{*/
            /*display: inline-block;*/
        /*}*/
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;

        height: 50px;
        width: 100%;
    }
    #chat-body{
        width: 100%;
        height: calc(100% - 110px);
    }
    #conversation-with-experts{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 10px;
        width: 100%;
        height: 559px;
    }



    .startBtn{
        background-color: white!important;
        color: #d95c08!important;
    }
    .active{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px!important;
        .clearBtn{
            height: 35px;
            width: 35px;
            text-align: center;
            line-height: 35px;
            font-size: 20px;
            border-radius: 50%!important;
            border: 1px solid #d95c08!important;
            background-color: white!important;
            color: #d95c08!important;
            &:hover{
                background-color:#d95c08!important;
                color:white!important;
            }
        }
        .sendBtn{
            height: 35px;
            width: 35px;
            text-align: center;
            line-height: 35px;
            font-size: 20px;
            border-radius: 50%!important;
            border: 1px solid #28988f!important;
            background-color: white!important;
            color: #28988f!important;
            &:hover{
                background-color:#28988f!important;
                color:white!important;
            }
        }
        .timer{
            display: block!important;
            height: 40px!important;
            width:60px!important;
            line-height: 40px;
            margin: 0 5px 0 5px;
            text-align: center;
        }
    }





</style>